import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
//import { useLocation } from 'react-router-dom';


//import logo from './logo2.png';
import './App.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUserCircle, faCaretDown } from '@fortawesome/free-solid-svg-icons';

//import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

// Importation des pages
import Presentation from './pages/Presentation';
import Locations from './pages/Locations';
import DetailPage from './pages/DetailPage';
import Ventes from './pages/Ventes';
import DetailsVente from './pages/DetailsVente';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Login from './pages/Connexion/Login';
import Signup from './pages/Connexion/Signup';
import Confirmation from './pages/Connexion/Confirmation';
import EmailSent from './pages/Connexion/EmailSent';
import Profile from './pages/Connexion/Profile';
import Articles from './pages/Articles';

//import BTPVentes from './pages/BtpMateriaux';
//import DetailProduitBtp from './pages/DetailProduitBtp';

//import DetailsBTP from './pages/DetailsBTP';


// Importation des sous-pages de locations
import Appartements from './pages/Appartements';
import Villas from './pages/Villas';
import Terrains from './pages/Terrains';
import Saisonniere from './pages/Saisonniere';
import Chambres from './pages/Chambres';

// Importation des pages services
import Gerance from './pages/Services/Gerance';
import Location from './pages/Services/Location';
import Vente from './pages/Services/Vente';
import EtudesExpertises from './pages/Services/EtudesExpertises';
import Consultances from './pages/Services/Consultances';
import BTP from './pages/Services/BTP';

// Importation des pages administrateur
import Ajouter from './pages/Admin/Ajouter';
import Modifier from './pages/Admin/Modifier';
import Supprimer from './pages/Admin/Supprimer';
import ModifierPage from './pages/Admin/ModifierPage';
import SupprimerPage from './pages/Admin/SupprimerPage';
import AdminLocations from './pages/Admin/LocationsPage';
import AdminArticles from './pages/Admin/ArticlesPage';
import AdminVentes from './pages/Admin/VentesPage';
import AjouterArticle from './pages/Admin/AjouterArticle';
import ModifierArticle from './pages/Admin/ModifierArticle';
import SupprimerArticle from './pages/Admin/SupprimerArticle';
import AjouterVente from './pages/Admin/AjouterVente';
import ModifierVente from './pages/Admin/ModifierVente';
import SupprimerVente from './pages/Admin/SupprimerVente';
import ListeVenteModifier from './pages/Admin/ListeVenteModifier';

import AdminBTP from './pages/Admin/BtpPage';
//import AjouterBTP from './pages/Admin/AjouterBTP';
//import ModifierBTP from './pages/Admin/ModifierBTP';
//import SupprimerBTP from './pages/Admin/SupprimerBTP';
//import ListeBTPModifier from './pages/Admin/ListeBTPModifier';


// Importation du Footer
import Footer from './components/Footer';
import QuiSommesNous from './components/QuiSommesNous';
// Importation de la FAQ
import Faq from './components/Faq';
// Importation des CGV
import Cgv from './components/Cgv';
// Importation de la page de confidentialité
import Confidentialite from './components/Confidentialite';
// Importation de la page de partenariat
import Partenariat from './components/Partenaires';

// Importation de l'API
import api from './api';


// Créer une instance Axios avec l'URL de base
/*const api = axios.create({
  baseURL: 'http://localhost:5000/api/properties', // Définir une fois l'URL de base
  //baseURL: 'https://booking-backend-3897450fe5a2.herokuapp.com/api/properties',
});*/

function App() {
  const [locations, setLocations] = useState([]);

  const [btpProduits, setBtpProduits] = useState([]);
  const [btpTotalPages, setBtpTotalPages] = useState(1);

  const [ventes, setVentes] = useState([]); // Pour les ventes si nécessaire
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Nouvel état pour la connexion
  const [showProfileMenu, setShowProfileMenu] = useState(false); // Pour afficher le menu du profil
  const [userRole, setUserRole] = useState(''); // Pour stocker le rôle de l'utilisateur
  const [userEmail, setUserEmail] = useState('');

  // Ajout pour la pagination et les filtres
  const [page, setPage] = useState(1);
  const [limit] = useState(10); // Définir une limite par page
  const [totalPages, setTotalPages] = useState(1);
  const [category, setCategory] = useState('');
  const [localisation, setLocalisation] = useState('');
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [sort, setSort] = useState('');
  const [search, setSearch] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [maxPriceQuery, setMaxPriceQuery] = useState('');

  // Fonction pour changer de prix maximum (ne met pas à jour directement maxPriceQuery)
  const handleMaxPriceChange = (newMaxPrice) => {
    setMaxPrice(newMaxPrice); // Mettre à jour maxPrice sans déclencher de recherche
  };

  // Fonction pour changer le tri
  const handleSortChange = (newSort) => {
    setSort(newSort);
    setPage(1); // Reset à la première page lors du changement de tri
  };

  // Fonction pour gérer les changements de l'input de recherche
  const handleSearchChange = (newSearch) => {
    setSearch(newSearch); // Met à jour l'état de recherche
  };

  // Fonction pour déclencher la recherche
  const handleSearchClick = () => {
    setSearchQuery(search); // Mettre à jour searchQuery pour déclencher la recherche
    setMaxPriceQuery(maxPrice); // Mettre à jour maxPriceQuery pour déclencher la recherche
    setPage(1); // Reset à la première page lors du changement de recherche
  };

  // Vérifier le token au chargement de l'application
  useEffect(() => {
    // Fonction pour récupérer les propriétés avec pagination et filtres
    const fetchLocations = async () => {
      try {
          const response = await api.get('/properties', {
              params: {
                  page,
                  limit,
                  category,
                  localisation,
                  sort,
                  search: searchQuery,
              },
          });

          let filteredProperties = response.data.properties;

          // Appliquer les filtres de prix côté front-end
          if (minPrice) {
            filteredProperties = filteredProperties.filter(property => property.details.price >= parseFloat(minPrice));
          }
          if (maxPriceQuery) {
            filteredProperties = filteredProperties.filter(property => property.details.price <= parseFloat(maxPriceQuery));
          }

          // Mettre à jour les propriétés et la pagination
          //setLocations(filteredProperties.slice((page - 1) * limit, page * limit));
          //setTotalPages(Math.ceil(filteredProperties.length / limit));
          setLocations(filteredProperties); // Retirez .slice() ici
          console.log('Propriétés récupérées:', filteredProperties);
          setTotalPages(Math.ceil(response.data.total / limit));
      } catch (error) {
          console.error('Erreur lors de la récupération des propriétés:', error);
      }
    };

    // Vérifier si l'utilisateur est déjà connecté
    const token = localStorage.getItem('authToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setIsLoggedIn(true);
        setUserRole(decoded.role);
        setUserEmail(decoded.email);
      } catch (error) {
        console.error('Token invalide:', error);
      }
    }

    // Appeler fetchLocations pour obtenir les données initiales
    fetchLocations(); 

  }, [page, limit, category, localisation, minPrice, maxPriceQuery, sort, searchQuery]); // Re-exécuter useEffect lorsque page, category, localisation changent


  // BTP catalogue supprimé - décommenté
  /*
  useEffect(() => {
    const fetchBtpProduits = async () => {
      try {
        const res = await api.get('/btp', {
          params: {
            page,
            limit: 10,
            category,
            localisation,
            minPrice,
            maxPrice,
            sort,
            search
          }
        });
        setBtpProduits(res.data.materiels);
        setBtpTotalPages(res.data.totalPages);
      } catch (error) {
        console.error('Erreur BTP:', error);
      }
    };
    fetchBtpProduits();
  }, [page, category, localisation, minPrice, maxPrice, sort, search]);
  */
  
  
  const fetchVentes = async () => {
    try {
      const response = await api.get('/sales', {
        params: {
          page,
          limit,
          category,
          localisation,
          sort,
          search: searchQuery,
        },
      });
  
      let filteredSales = response.data.sales;
  
      // Appliquer les filtres de prix côté front-end
      if (minPrice) {
        filteredSales = filteredSales.filter(sale => sale.details.price >= parseFloat(minPrice));
      }
      if (maxPriceQuery) {
        filteredSales = filteredSales.filter(sale => sale.details.price <= parseFloat(maxPriceQuery));
      }
  
      setVentes(filteredSales);
      setTotalPages(Math.ceil(response.data.total / limit));
    } catch (error) {
      console.error('Erreur lors de la récupération des ventes:', error);
    }
  };
  
  
  useEffect(() => {
    fetchVentes();
  }, [page, limit, category, localisation, minPrice, maxPriceQuery, sort, searchQuery]);
  
  
  // Fonction pour changer de page
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // Fonction pour changer de catégorie
  const handleCategoryChange = (newCategory) => {
    setCategory(newCategory);
    setPage(1); // Reset à la première page lors du changement de filtre
  };

  // Fonction pour changer de localisation
  const handleLocalisationChange = (newLocalisation) => {
    setLocalisation(newLocalisation);
    setPage(1); // Reset à la première page lors du changement de filtre
  };

  // Fonction pour changer de prix minimum
  const handleMinPriceChange = (newMinPrice) => {
    setMinPrice(newMinPrice);
    setPage(1); // Reset à la première page lors du changement de filtre
  };

  // Fonction pour changer de prix maximum
  // Fonction de connexion (à appeler après une connexion réussie)
  const handleLogin = (token) => {
    try {
      const decoded = jwtDecode(token);
      setIsLoggedIn(true);
      setUserRole(decoded.role);
      setUserEmail(decoded.email);
      localStorage.setItem('authToken', token);
    } catch (error) {
      console.error('Erreur lors de la connexion:', error);
    }
  };

  // Fonction de déconnexion
  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserRole('');
    setUserEmail('');
    setShowProfileMenu(false); // Fermer le menu de profil
    localStorage.removeItem('authToken');
    setMobileViewSubMenu(null);
    // Ajoutez ici une logique pour gérer la déconnexion (par exemple, supprimer le token de session)
  };

  // Gestion de l'affichage du menu de profil
  const toggleProfileMenu = () => {
    setShowProfileMenu(!showProfileMenu);
  };
  
  // Fonction pour ajouter une nouvelle location
  const handleAddLocation = (newLocation) => {
    setLocations([...locations, newLocation]);
  };

  // Fonction pour mettre à jour une location
  const handleUpdateLocation = async (updatedLocation) => {
    try {
      // Faire un appel API PUT pour mettre à jour la propriété dans la base de données
      //const response = await axios.put(`http://localhost:5000/api/properties/${updatedLocation._id}`, updatedLocation);
      const response = await api.put(`/properties/${updatedLocation._id}`, updatedLocation);
      console.log("✅ Propriété mise à jour :", response.data);
      
      // Mettre à jour l'état local si la modification a été réussie
      setLocations((prevLocations) =>
        prevLocations.map((location) =>
          location._id === updatedLocation._id ? response.data : location
        )
      );
      console.log('Propriété mise à jour avec succès:', response.data);
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la propriété:', error);
      alert('Erreur lors de la mise à jour de la propriété.');
    }
  };  
  
  // Fonction pour supprimer une location dans la BDD et l'état local
  const handleDeleteLocation = async (_id) => {
    try {
      //await axios.delete(`http://localhost:5000/api/properties/${_id}`);
      await api.delete(`/properties/${_id}`);
      setLocations((prevLocations) =>
        prevLocations.filter((location) => location._id !== _id)
      );
    } catch (error) {
      console.error('Erreur lors de la suppression de la propriété:', error);
    }
  };


  // États pour la gestion du menu mobile
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState({});

  const [dropdownOpen, setDropdownOpen] = useState({
    locations: false, 
    ventes: false,
    services: false,
    conseils: false
  });


  const toggleDropdown = (menu) => {
    if (window.innerWidth > 768) {
      setDropdownOpen((prev) => ({
        ...prev,
        [menu]: !prev[menu],
      }));
    } else {
      setMobileDropdownOpen((prev) => ({
        ...prev,
        [menu]: !prev[menu],
      }));
    }
  };
  
  const closeAllMenus = () => {
    setDropdownOpen({
      locations: false,
      ventes: false,
      services: false,
      conseils: false,
    });
    setMobileDropdownOpen({});
    setMenuOpen(false);
  };
  
  const handleMenuClick = () => {
    setMobileViewSubMenu(null);
  };
  
  const handleSubMenuItemClick = () => {
    setMobileViewSubMenu(null);
  };

  const [mobileViewSubMenu, setMobileViewSubMenu] = useState(null); // null, 'locations', 'ventes', 'services'

  const handleMobileMenuClick = (menuName) => {
    if (window.innerWidth <= 768) {
      setMobileViewSubMenu(menuName);
      setMenuOpen(false); // on ferme le menu principal
    } else {
      toggleDropdown(menuName); // pour desktop
    }
  };
  
  /*const handleBackToMobileMainMenu = () => {
    setMobileViewSubMenu(null);
  };*/
  
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          {/* Barre de menu */}
          <nav className="navbar">
            <div className="navbar-container">
              <div className="navbar-home">
                <Link to="/" onClick={closeAllMenus} className="navbar-logo-link">
                  <img src="/logo130426.jpg" className="navbar-logo" alt="CICJ Logo" />
                </Link>
              </div>

              <button className="navbar-toggle" onClick={() => {
                setMenuOpen(!menuOpen);
                setMobileDropdownOpen({}); // Fermer tous les dropdowns mobiles
                setMobileViewSubMenu(null);
              }}>
                ☰
              </button>

              {mobileViewSubMenu && (
                <ul className="navbar-menu active mobile-submenu">
                  <li></li>
                  {mobileViewSubMenu === 'louer' && (
                    <>
                      <li><Link to="/louer" onClick={handleSubMenuItemClick}>Tout</Link></li>
                      <li><Link to="/louer/appartements" onClick={handleSubMenuItemClick}>Appartements</Link></li>
                      <li><Link to="/louer/villas" onClick={handleSubMenuItemClick}>Villas/Bureaux</Link></li>
                      <li><Link to="/louer/saisonnieres" onClick={handleSubMenuItemClick}>Saisonnières</Link></li>
                      <li><Link to="/louer/chambres-studios" onClick={handleSubMenuItemClick}>Chambres/Studios</Link></li>
                    </>
                  )}
                  {mobileViewSubMenu === 'admin' && userRole === 'admin' && (
                    <>
                      <li><Link to="/admin/locations" onClick={handleSubMenuItemClick}>Locations</Link></li>
                      <li><Link to="/admin/articles" onClick={handleSubMenuItemClick}>Articles</Link></li>
                      <li><Link to="/admin/ventes" onClick={handleSubMenuItemClick}>Ventes</Link></li>
                    </>
                  )}
                </ul>
              )}

              
              <ul className={`navbar-menu ${menuOpen ? 'active' : ''}`}>

                {/* Louer Dropdown */}
                <li className={`dropdown ${dropdownOpen.locations || mobileDropdownOpen.locations ? 'open' : ''}`}>
                  <div onClick={() => handleMobileMenuClick('louer')}>
                    <Link to="/louer">Louer</Link>
                  </div>
                  {(window.innerWidth > 768 || mobileDropdownOpen.locations) && (
                    <ul className="dropdown-content">
                      <li><Link to="/louer/appartements" onClick={handleSubMenuItemClick}>Appartements</Link></li>
                      <li><Link to="/louer/villas" onClick={handleSubMenuItemClick}>Villas/Bureaux</Link></li>
                      <li><Link to="/louer/saisonnieres" onClick={handleSubMenuItemClick}>Saisonnières</Link></li>
                      <li><Link to="/louer/chambres-studios" onClick={handleSubMenuItemClick}>Chambres/Studios</Link></li>
                    </ul>
                  )}
                </li>

                <li><Link to="/acheter" onClick={handleMenuClick && closeAllMenus}>Acheter</Link></li>

                <li><Link to="/confier-mon-bien" onClick={handleMenuClick && closeAllMenus}>Confier mon bien</Link></li>

                <li><Link to="/projet-immobilier" onClick={handleMenuClick && closeAllMenus}>Projet immobilier</Link></li>

                <li><Link to="/conseils-consultance" onClick={handleMenuClick && closeAllMenus}>Conseils & Consultance</Link></li>

                <li><Link to="/btp-construction" onClick={handleMenuClick && closeAllMenus}>Ingénierie & BTP</Link></li>

                <li><Link to="/contact" onClick={closeAllMenus}>Contact</Link></li>

                {!isLoggedIn && (
                  <li><Link to="/login" onClick={closeAllMenus}>Connexion</Link></li>
                )}

                {userRole === 'admin' && (
                  <li className="dropdown">
                    <div onClick={() => handleMobileMenuClick('admin')}>
                      <Link to="#" className="menu-admin" onClick={(e) => e.preventDefault()}>Administrateur</Link>
                    </div>
                    <ul className="dropdown-content">
                      <li><Link to="/admin/locations">Locations</Link></li>
                      <li><Link to="/admin/articles">Articles</Link></li>
                      <li><Link to="/admin/ventes">Ventes</Link></li>
                    </ul>
                  </li>
                )}
                
                {isLoggedIn && (
                  <li className="profile-menu">
                    <div className="profile-icon" onClick={toggleProfileMenu}>
                      <FontAwesomeIcon icon={faUserCircle} className="user-icon" />
                      <FontAwesomeIcon icon={faCaretDown} className="caret-icon" />
                    </div>
                    {showProfileMenu && (
                      <div className="profile-dropdown">
                        <Link to="/profile" onClick={handleMenuClick}>Infos du profil</Link>
                        <button onClick={handleLogout}>Déconnexion</button>
                      </div>
                    )}
                  </li>
                )}

                
              </ul>

              {/* <div className="navbar-contact">
                <Link to="tel:+221338245500">
                    <FontAwesomeIcon icon={faPhone} className="phone-icon" />
                </Link>
                <a href="tel:+221338245500">+221 33 100 00 00</a>
              </div> */}
  
            </div>
          </nav>
        </header>

        {/* Contenu des pages */}
        <main>
          <Routes>
            <Route path="/presentation" element={<Presentation />} />
            <Route path="/louer" element={
              <Locations 
                locations={locations} 
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onCategoryChange={handleCategoryChange}
                onLocalisationChange={handleLocalisationChange}
                onMinPriceChange={handleMinPriceChange}
                onMaxPriceChange={handleMaxPriceChange}
                onSortChange={handleSortChange}
                onSearchClick={handleSearchClick}
                onSearchChange={handleSearchChange}
                minPrice={minPrice}
                maxPrice={maxPrice}
                category={category}
                localisation={localisation}
              />
            } />
            {/* Anciennes routes redirigées */}
            <Route path="/locations" element={
              <Locations 
                locations={locations} 
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onCategoryChange={handleCategoryChange}
                onLocalisationChange={handleLocalisationChange}
                onMinPriceChange={handleMinPriceChange}
                onMaxPriceChange={handleMaxPriceChange}
                onSortChange={handleSortChange}
                onSearchClick={handleSearchClick}
                onSearchChange={handleSearchChange}
                minPrice={minPrice}
                maxPrice={maxPrice}
                category={category}
                localisation={localisation}
              />
            } />
            <Route path="/detail/:id" element={<DetailPage locations={locations} />} />
            <Route path="/acheter" element={
              <Ventes 
                locations={ventes}
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onCategoryChange={handleCategoryChange}
                onLocalisationChange={handleLocalisationChange}
                onMinPriceChange={handleMinPriceChange}
                onMaxPriceChange={handleMaxPriceChange}
                onSortChange={handleSortChange}
                onSearchClick={handleSearchClick}
                onSearchChange={handleSearchChange}
                minPrice={minPrice}
                maxPrice={maxPrice}
                category={category}
                localisation={localisation}
              />
            } />
            <Route path="/ventes" element={
              <Ventes 
                locations={ventes}
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onCategoryChange={handleCategoryChange}
                onLocalisationChange={handleLocalisationChange}
                onMinPriceChange={handleMinPriceChange}
                onMaxPriceChange={handleMaxPriceChange}
                onSortChange={handleSortChange}
                onSearchClick={handleSearchClick}
                onSearchChange={handleSearchChange}
                minPrice={minPrice}
                maxPrice={maxPrice}
                category={category}
                localisation={localisation}
              />
            } />
            <Route path="/ventes/detail/:id" element={<DetailsVente />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/confirmation" element={<Confirmation />} />
            <Route path="/email-sent" element={<EmailSent />} />
            <Route path="/profile" element={<Profile userEmail={userEmail} />} />
            <Route path="/" element={<Home />} />

            {/* Routes sous-pages louer */}
            <Route path="/louer/appartements" element={
              <Appartements 
                locations={locations} 
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onCategoryChange={handleCategoryChange}
                onLocalisationChange={handleLocalisationChange}
                onMinPriceChange={handleMinPriceChange}
                onMaxPriceChange={handleMaxPriceChange}
                onSortChange={handleSortChange}
                onSearchClick={handleSearchClick}
                onSearchChange={handleSearchChange}
                minPrice={minPrice}
                maxPrice={maxPrice}
                category={category}
                localisation={localisation}
              />
            } />
            <Route path="/louer/villas" element={
              <Villas 
                locations={locations} 
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onCategoryChange={handleCategoryChange}
                onLocalisationChange={handleLocalisationChange}
                onMinPriceChange={handleMinPriceChange}
                onMaxPriceChange={handleMaxPriceChange}
                onSortChange={handleSortChange}
                onSearchClick={handleSearchClick}
                onSearchChange={handleSearchChange}
                minPrice={minPrice}
                maxPrice={maxPrice}
                category={category}
                localisation={localisation}
              />
            } />
            <Route path="/louer/saisonnieres" element={
              <Saisonniere 
                locations={locations} 
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onCategoryChange={handleCategoryChange}
                onLocalisationChange={handleLocalisationChange}
                onMinPriceChange={handleMinPriceChange}
                onMaxPriceChange={handleMaxPriceChange}
                onSortChange={handleSortChange}
                onSearchClick={handleSearchClick}
                onSearchChange={handleSearchChange}
                minPrice={minPrice}
                maxPrice={maxPrice}
                category={category}
                localisation={localisation}
              />
            } />
            <Route path="/louer/chambres-studios" element={
              <Chambres
                locations={locations} 
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onCategoryChange={handleCategoryChange}
                onLocalisationChange={handleLocalisationChange}
                onMinPriceChange={handleMinPriceChange}
                onMaxPriceChange={handleMaxPriceChange}
                onSortChange={handleSortChange}
                onSearchClick={handleSearchClick}
                onSearchChange={handleSearchChange}
                minPrice={minPrice}
                maxPrice={maxPrice}
                category={category}
                localisation={localisation}
              />
            } />

            {/* Anciennes routes locations (rétro-compat) */}
            <Route path="/locations-appartements" element={
              <Appartements 
                locations={locations} 
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onCategoryChange={handleCategoryChange}
                onLocalisationChange={handleLocalisationChange}
                onMinPriceChange={handleMinPriceChange}
                onMaxPriceChange={handleMaxPriceChange}
                onSortChange={handleSortChange}
                onSearchClick={handleSearchClick}
                onSearchChange={handleSearchChange}
                minPrice={minPrice}
                maxPrice={maxPrice}
                category={category}
                localisation={localisation}
              />
            } />
            <Route path="/locations-villas" element={
              <Villas 
                locations={locations} 
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onCategoryChange={handleCategoryChange}
                onLocalisationChange={handleLocalisationChange}
                onMinPriceChange={handleMinPriceChange}
                onMaxPriceChange={handleMaxPriceChange}
                onSortChange={handleSortChange}
                onSearchClick={handleSearchClick}
                onSearchChange={handleSearchChange}
                minPrice={minPrice}
                maxPrice={maxPrice}
                category={category}
                localisation={localisation}
              />
            } />
            <Route path="/locations-saisonnieres" element={
              <Saisonniere 
                locations={locations} 
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onCategoryChange={handleCategoryChange}
                onLocalisationChange={handleLocalisationChange}
                onMinPriceChange={handleMinPriceChange}
                onMaxPriceChange={handleMaxPriceChange}
                onSortChange={handleSortChange}
                onSearchClick={handleSearchClick}
                onSearchChange={handleSearchChange}
                minPrice={minPrice}
                maxPrice={maxPrice}
                category={category}
                localisation={localisation}
              />
            } />
            <Route path="/locations-chambres-studios" element={
              <Chambres
                locations={locations} 
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onCategoryChange={handleCategoryChange}
                onLocalisationChange={handleLocalisationChange}
                onMinPriceChange={handleMinPriceChange}
                onMaxPriceChange={handleMaxPriceChange}
                onSortChange={handleSortChange}
                onSearchClick={handleSearchClick}
                onSearchChange={handleSearchChange}
                minPrice={minPrice}
                maxPrice={maxPrice}
                category={category}
                localisation={localisation}
              />
            } />

            {/* Nouvelles pages */}
            <Route path="/confier-mon-bien" element={<Gerance />} />
            <Route path="/projet-immobilier" element={<EtudesExpertises />} />
            <Route path="/conseils-consultance" element={<Consultances />} />
            <Route path="/btp-construction" element={<BTP />} />
            <Route path="/articles" element={<Articles />} />

            {/* Anciennes routes services (rétro-compat) */}
            <Route path="/services/gerance" element={<Gerance />} />
            <Route path="/services/location" element={<Location />} />
            <Route path="/services/vente" element={<Vente />} />
            <Route path="/services/etudes-expertises" element={<EtudesExpertises />} />
            <Route path="/services/consultances" element={<Consultances />} />
            <Route path="/services/btp" element={<BTP />} />

            {/* Routes des pages administrateur */}
            <Route path="/admin/ajouter" element={<Ajouter onAddLocation={handleAddLocation} />} />
            <Route path="/admin/modifier" element={
              <Modifier 
                locations={locations} 
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            } />
            <Route path="/admin/modifier/:id" element={<ModifierPage locations={locations} onUpdateLocation={handleUpdateLocation} />} />
            <Route path="/admin/supprimer" element={
              <Supprimer 
                locations={locations} 
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            } />
            <Route path="/admin/supprimer/:id" element={<SupprimerPage locations={locations} onDeleteLocation={handleDeleteLocation} />} />
            <Route path="/admin/locations" element={<AdminLocations />} />
            <Route path="/admin/articles" element={<AdminArticles />} />
            <Route path="/admin/ventes" element={<AdminVentes />} />
            <Route path="/admin/articles/ajouter" element={<AjouterArticle />} />
            <Route path="/admin/articles/modifier" element={<ModifierArticle />} />
            <Route path="/admin/articles/supprimer" element={<SupprimerArticle />} />
            <Route path="/admin/ventes/ajouter" element={<AjouterVente />} />
            <Route path="/admin/ventes/supprimer" element={<SupprimerVente />} />
            <Route path="/admin/ventes/modifier" element={<ListeVenteModifier />} />
            <Route path="/admin/ventes/modifier/:id" element={<ModifierVente />} />
            <Route path="/modifier-vente/:id" element={<ModifierVente />} />

            <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/cgv" element={<Cgv />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/partenaires" element={<Partenariat />} />

          </Routes>
        </main>
        {/* Bouton WhatsApp flottant */}
        <a
          href="https://wa.me/221776759906?text=Bonjour%2C%20je%20souhaite%20des%20informations%20sur%20vos%20services%20immobiliers"
          className="whatsapp-float"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Contactez-nous sur WhatsApp"
        >
          <svg viewBox="0 0 32 32" className="whatsapp-icon-svg">
            <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.132 6.742 3.054 9.378L1.054 31.384l6.262-1.974C9.876 31.076 12.82 32 16.004 32 24.826 32 32 24.826 32 16.004 32 7.176 24.826 0 16.004 0zm9.302 22.594c-.388 1.094-1.938 2.002-3.156 2.266-.832.178-1.918.318-5.574-1.198-4.674-1.938-7.684-6.69-7.92-6.998-.226-.308-1.892-2.52-1.892-4.806 0-2.286 1.198-3.412 1.622-3.876.388-.424.918-.6 1.226-.6.15 0 .284.008.404.014.424.018.636.042.916.712.35.834 1.198 2.912 1.302 3.124.106.212.212.494.07.778-.13.29-.248.47-.46.72-.212.248-.438.554-.626.742-.212.212-.432.444-.186.868.248.424 1.098 1.81 2.358 2.932 1.62 1.44 2.986 1.888 3.41 2.096.424.212.672.178.92-.106.248-.284 1.062-1.234 1.344-1.66.284-.424.566-.354.954-.212.388.142 2.462 1.16 2.884 1.372.424.212.706.318.812.494.104.178.104 1.022-.284 2.116z" fill="currentColor"/>
          </svg>
        </a>
        {/* Ajout du footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;